import { api, setAccessToken, setRefreshToken } from "./client";

export async function registerUser(email: string, password: string, displayName: string) {
    const { data } = await api.post("/api/auth/register", { email, password, displayName });
    if (data?.accessToken) {
        setAccessToken(data.accessToken);
        if (data.refreshToken) setRefreshToken(data.refreshToken);
    }
    return data;
}